export const apiConstants = {
  BEGIN_API_CALL: 'BEGIN_API_CALL',
  END_API_CALL: 'END_API_CALL'
};
